import { useMemo } from 'react';
import { bytesToFlagData, generateSVG, svgToDataUri } from '@/lib/flagUtils';

interface FlagSVGProps {
  bytes: number[];
  className?: string;
  width?: number;
  height?: number;
}

export function FlagSVG({ bytes, className, width = 800, height = 500 }: FlagSVGProps) {
  const svg = useMemo(() => {
    if (bytes.length === 0) return '';
    const data = bytesToFlagData(bytes);
    if (data.stripes.length === 0) return '';
    return generateSVG(data, width, height);
  }, [bytes, width, height]);

  if (!svg) {
    return (
      <div
        className={className}
        style={{ aspectRatio: '8/5', background: '#e5e7eb' }}
      >
        <div className="w-full h-full flex items-center justify-center text-gray-400 text-sm">
          Enter data to generate flag
        </div>
      </div>
    );
  }

  const src = svgToDataUri(svg);

  return (
    <img
      src={src}
      alt="Free Speech Flag"
      className={className}
      style={{ aspectRatio: '8/5', display: 'block' }}
      draggable={false}
    />
  );
}

/** Return the raw SVG string for a byte array */
export function getFlagSVGString(bytes: number[], width = 800, height = 500): string {
  if (bytes.length < 3) return '';
  const data = bytesToFlagData(bytes);
  if (data.stripes.length === 0) return '';
  return generateSVG(data, width, height);
}
